/**
 * audit-lib.ts — Hàm thuần cho màn Nhật ký kiểm toán (lọc → query string,
 * chữ hiển thị cột Thiết bị, khoảng ngày nhanh). Tách riêng để test được.
 */
import { currentLocale, i18n } from '@/lib/i18n'

export interface AuditFilters {
  from?: string // YYYY-MM-DD (giờ VN)
  to?: string
  userId?: string
  module?: string
  success?: '' | 'true' | 'false'
  /** Nhật ký trạng thái trực tuyến: online | busy | offline ('all' / trống = tất cả). */
  status?: string
  page?: number
  limit?: number
  mine?: boolean
}

/** Bỏ ô trống / 'all' để URL gọn và backend không phải đoán. */
export function toAuditParams(f: AuditFilters): Record<string, string> {
  const p: Record<string, string> = {}
  if (f.from) p.from = f.from
  if (f.to) p.to = f.to
  if (f.userId && f.userId !== 'all') p.userId = f.userId
  if (f.module && f.module !== 'all') p.module = f.module
  if (f.success === 'true' || f.success === 'false') p.success = f.success
  if (f.status && f.status !== 'all') p.status = f.status
  if (f.page && f.page > 1) p.page = String(f.page)
  if (f.limit) p.limit = String(f.limit)
  if (f.mine) p.mine = '1'
  return p
}

const DEVICE: Record<string, () => string> = {
  desktop: () => i18n.t('settings:audit.device.desktop'),
  mobile: () => i18n.t('settings:audit.device.mobile'),
  tablet: () => i18n.t('settings:audit.device.tablet'),
}

/** "Máy tính · Chrome 129 · macOS" — bỏ phần thiếu; không có gì → "Không rõ". */
export function deviceText(r: { deviceType?: string | null; browser?: string | null; os?: string | null }): string {
  const parts = [r.deviceType ? DEVICE[r.deviceType]?.() ?? r.deviceType : null, r.browser, r.os].filter(Boolean)
  return parts.length ? parts.join(' · ') : i18n.t('settings:audit.device.unknown')
}

/** Ngày YYYY-MM-DD theo giờ Việt Nam. */
export function vnDate(d: Date): string {
  return new Date(d.getTime() + 7 * 3600_000).toISOString().slice(0, 10)
}

/** Khoảng nhanh: hôm nay / 7 / 30 ngày gần nhất (tính cả hôm nay). */
export function quickRange(days: 1 | 7 | 30, now = new Date()): { from: string; to: string } {
  const to = vnDate(now)
  const from = vnDate(new Date(now.getTime() - (days - 1) * 86_400_000))
  return { from, to }
}

export function formatTime(iso: string): string {
  return new Date(iso).toLocaleString(currentLocale(), { hour12: false })
}

export const FAILURE_LABELS: Record<string, string> = {
  get wrong_password() { return i18n.t('settings:audit.failures.wrongPassword') },
  get inactive() { return i18n.t('settings:audit.failures.inactive') },
  get org_expired() { return i18n.t('settings:audit.failures.orgExpired') },
  get org_suspended() { return i18n.t('settings:audit.failures.orgSuspended') },
}

export const IP_CHANGED_WARNING: () => string = () => i18n.t('settings:audit.ipChangedWarning')
